import { combineReducers } from 'redux'
// import globalReducer from 'containers/App/reducer'
import globalReducer from 'slices/globalSlice'
import appReducer from 'slices/appSlice'
import customerSupportReducer from 'slices/customerSupportSlice'
import travelReducer from 'slices/travelSlice'
import tripProtectionReducer from 'slices/tripProtectionSlice'
import kyxReducer from 'slices/kyxSlice'

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    global: globalReducer,
    app: appReducer,
    customerSupport: customerSupportReducer,
    travel: travelReducer,
    tripProtection: tripProtectionReducer,
    kyx: kyxReducer,
    ...injectedReducers,
  })

  return rootReducer
}
